var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 16.2812C46.8594 16.625 47.7188 19.375 46.0859 21.0078L37.0625 29.8594L39.2109 42.3203C39.5547 44.5547 37.1484 46.2734 35.1719 45.2422L24 39.3125L12.7422 45.2422C10.7656 46.2734 8.35938 44.5547 8.70312 42.3203L10.8516 29.8594L1.82812 21.0078C0.195312 19.375 1.05469 16.625 3.28906 16.2812L15.9219 14.4766L21.5078 3.04688C22.5391 0.984375 25.4609 1.07031 26.4062 3.04688L32.0781 14.4766L44.625 16.2812ZM34.0547 28.8281L44.1953 19.0312L30.1875 16.9688L24 4.25L17.7266 16.9688L3.71875 19.0312L13.8594 28.8281L11.4531 42.75L24 36.2188L36.4609 42.75L34.0547 28.8281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.e15bef5371454300c561bd7ee1d1ce13.svg";
export { ForwardRef as ReactComponent };